class MFRFlipCard {
  constructor(index, element) {
    this.$index = index
    this.$element = $(element)

    this.$target = this.$element.find('.flip-inner')
    this.$trigger = this.$element.find('.flip-trigger')

    this.init()
  }

  init() {
    this.$trigger.on('click', this.flipCard.bind(this))
  }

  flipCard() {
    this.$target.toggleClass('flip-over')
    this.$trigger.toggleClass('is-active')
  }
} 